import {
  SELF,
  TEAMS,
  KITS,
  OBJECTS,
  SET_OBJECT,
  RESET_OBJECT,
  LOADING,
  RESET,
  RESET_DETECT_FOR_EDITING,
  RESET_FIELD_DATA,
  SET_CURRENT_FRAME,
  SET_BACKGROUND,
  SET_CANVAS_SIZE,
  SET_DETECT_LABELS,
  SET_EVENT,
  SET_EVENT_FILTER,
  SET_EVENT_TYPES,
  SET_EVENT_LOADING,
  SET_EVENTS,
  SET_EVENTS_LOADING,
  SET_EVENTS_PAGE,
  SET_DETECT_FOR_EDITING,
  SET_GAME_STATISTICS_LOADING,
  SET_PLAYERS_STATISTICS_LOADING,
  SET_PREVIOUS_NEW_DETECT,
  SET_INTERPOLATED_VISIBILITY,
  SET_LOGS,
  SET_LOGS_LOADING,
  SET_LOGS_LOOP,
  SET_DETECTS_TYPE,
  SET_FIELD_DATA,
  SET_FIELD_LABEL_VISIBILITY,
  SET_FILTERED_DETECTS,
  SET_SHOW_ONLY_DETECT,
  SET_ACTION,
  SET_STATISTICS,
  SET_TEAM_SHAPES_VISIBILITY,
  SET_VIEW,
  SET_VISIBILITY_CANVAS,
  SET_VISIBILITY_LINEUPS,
} from './mutation-types';
import * as types from './mutation-types';
import { getDefaultState } from './state';

export default {
  [SELF](state, payload) {
    state.self = payload;
  },
  [TEAMS](state, payload) {
    state.teams = payload;
  },
  [KITS](state, payload) {
    state.kits = payload;
  },
  [OBJECTS](state, payload) {
    state.detects = payload;
  },
  [SET_OBJECT](state, payload) {
    state.selectedObject = payload;
  },
  [RESET_OBJECT](state) {
    state.selectedObject = null;
  },
  [RESET_DETECT_FOR_EDITING](state) {
    state.detectCurrent = null;
  },
  [types.RESET_EVENTS_NEW](state) {
    state.eventsNew = [];
  },
  [RESET_FIELD_DATA](state) {
    state.field.id = null;
    state.field.points = [];
  },
  [SET_CURRENT_FRAME](state, payload) {
    state.currentFrame = payload;
  },
  [LOADING](state, { type, loading }) {
    state[type].loading = loading;
  },
  [SET_BACKGROUND](state, { type, img }) {
    state[type].img = img;
  },
  [SET_CANVAS_SIZE](state, { type, ...options }) {
    state[type].size = options;
  },
  [SET_DETECT_LABELS](state, payload) {
    state.filters.detectLabels = payload;
  },
  [SET_EVENT](state, payload) {
    state.event = payload;
  },
  [SET_EVENT_FILTER](state, payload) {
    state.events.filters.type = payload;
  },
  [types.SET_EVENT_SEARCH](state, payload) {
    state.events.filters.search = payload;
  },
  [SET_EVENT_TYPES](state, payload) {
    state.eventTypes = payload;
  },
  [SET_EVENT_LOADING](state, payload) {
    state.event.loading = payload;
  },
  [SET_EVENTS](state, payload) {
    state.events = payload;
  },
  [SET_EVENTS_LOADING](state, payload) {
    state.events.loading = payload;
  },
  [types.SET_EVENTS_NEW](state, payload) {
    state.eventsNew = payload;
  },
  [SET_EVENTS_PAGE](state, payload) {
    state.events.page = payload;
  },
  [SET_VISIBILITY_CANVAS](state, { type, value }) {
    state[type].visible = value;
  },
  [SET_DETECT_FOR_EDITING](state, payload) {
    state.detectCurrent = payload;
  },
  [SET_LOGS](state, payload) {
    state.logs = payload;
  },
  [SET_LOGS_LOADING](state, payload) {
    state.logs.loading = payload;
  },
  [SET_LOGS_LOOP](state, payload) {
    state.logs.loop = payload;
  },
  [SET_DETECTS_TYPE](state, payload) {
    state.filters.detectTypes = payload;
  },
  [SET_FIELD_DATA](state, payload) {
    state.field = payload;
  },
  [SET_FIELD_LABEL_VISIBILITY](state, payload) {
    state.field.showLabel = payload;
  },
  [SET_FILTERED_DETECTS](state, payload) {
    state.detectsFiltered = payload;
  },
  [SET_INTERPOLATED_VISIBILITY](state, payload) {
    state.filters.interpolated = payload;
  },
  [SET_SHOW_ONLY_DETECT](state, payload) {
    state.filters.showSelectedDetect = payload;
  },
  [SET_ACTION](state, payload) {
    state.action = payload;
  },
  [SET_GAME_STATISTICS_LOADING](state, payload) {
    state.statistic.game.loading = payload;
  },
  [SET_PLAYERS_STATISTICS_LOADING](state, payload) {
    state.statistic.players.loading = payload;
  },
  [SET_PREVIOUS_NEW_DETECT](state, payload) {
    state.prevNewDetect = payload;
  },
  [SET_STATISTICS](state, payload) {
    state.statistic = payload;
  },
  [SET_TEAM_SHAPES_VISIBILITY](state, payload) {
    state.statistic.showTeamShapes = payload;
  },
  [SET_VIEW](state, payload) {
    state.view = payload;
  },
  [SET_VISIBILITY_LINEUPS](state, payload) {
    state.filters.lineups = payload;
  },
  [RESET](state) {
    Object.assign(state, getDefaultState())
  },
};
